/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { getAccessToken, getVisitId } from "@lib/shared/cookies";
import Script from "next/script";
import { ReactElement, useEffect, useState } from "react";

export type WindowType = Window &
    typeof globalThis & { interval: NodeJS.Timeout & number };

const InspectorScript = ({
    startRecording,
}: {
    startRecording?: boolean | undefined;
}): ReactElement => {
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [visitId, setVisitId] = useState<string | null>(null);

    useEffect(() => {
        setAccessToken(getAccessToken() as string);
        setVisitId(getVisitId() as string);
        // @ts-ignore
        window.getAccessToken = getAccessToken;
        if (!startRecording) {
            setTimeout(() => {
                window?.clearInterval((window as WindowType).interval);
            }, 5000);
        }
    }, [startRecording]);

    return (
        <>
            <Script src="https://cdn.trafficbox.com/assets/inspector.min.js" />

            {accessToken && visitId && (window as any)?.inspector ? (
                <Script
                    id="inspector"
                    dangerouslySetInnerHTML={{
                        __html: `
                        if(${String(startRecording)}){
                        let events = [];
                        const intervalTime = 5000;
                        inspector.record({
                            emit(event) {
                                // push event into the events array
                                events.push(event);
                            },
                        });

                        // this function will send events to the backend and reset the events array
                        function save() {
                            const token = window.getAccessToken();
                            if(!token) {
                                window.location.reload();
                                return;
                            };
                            if (events.length == 0 ) return;
                            const body = JSON.stringify({ events: events, visitorId: "${visitId}", domain: "several.com" });
                            events = [];
                            fetch("/api/inspector", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": 'Bearer ${accessToken}',
                                },
                                body,
                            });
                        }
                        window.interval = setInterval(save, intervalTime);
                    }
                `,
                    }}
                />
            ) : null}
        </>
    );
};
export default InspectorScript;
